import { merge } from '../../helper';
import removeClass from '../../general/class/removeClass';

import * as exSelect from './';

// ----------------------------------------------------------------------------

export type TypeSelectElements = HTMLSelectElement | HTMLSelectElement[];

export type TypeGeneralConfig = {
    validation?: Record<string, any>;
};

// ----------------------------------------------------------------------------

function general(elements: TypeSelectElements, config?: TypeGeneralConfig): void {
    text(elements);
    validation(elements, config?.validation);
}

// ----------------------------------------------------------------------------

function text(elements: TypeSelectElements): void {
    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        exSelect.setValue(element, '');
    }
}

function validation(elements: TypeSelectElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        className: 'is-valid is-invalid',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        removeClass(element, defConfig.className);
    }
}

// ----------------------------------------------------------------------------

export { general, text, validation };
